import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { siteEventApi } from '../api';
import { SiteEvent } from '../types';
import { toImageUrl } from '../utils/image';
import { EventListItem, WELCOME_EVENT } from '../data/events';
import { SHOW_WELCOME_COUPON } from '../config/features';

const EventsListPage: React.FC = () => {
  const [events, setEvents] = useState<SiteEvent[]>([]);

  useEffect(() => {
    siteEventApi.getList().then(r => setEvents(r.data.data)).catch(() => setEvents([]));
  }, []);

  const items: EventListItem[] = [
    ...(SHOW_WELCOME_COUPON ? [WELCOME_EVENT] : []),
    ...events.map(e => ({ id: String(e.id), title: e.title, imageUrl: toImageUrl(e.imageUrl), ended: e.ended })),
  ];

  return (
    <div style={s.page}>
      <h2 style={s.title}>Events</h2>
      <div style={s.grid}>
        {items.map(e => (
          <Link key={e.id} to={`/events/${e.id}`} style={s.card}>
            <img src={e.imageUrl} alt={e.title} style={s.thumb} />
            <div style={s.body}>
              <span style={{ ...s.badge, ...(e.ended ? s.badgeEnded : s.badgeOngoing) }}>
                {e.ended ? 'Ended' : 'Ongoing'}
              </span>
              <div style={s.cardTitle}>{e.title}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const s: Record<string, React.CSSProperties> = {
  page: { maxWidth: 960, margin: '40px auto', padding: '0 20px' },
  title: { fontSize: 24, fontWeight: 800, color: '#333', marginBottom: 24 },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 20 },
  card: { display: 'block', borderRadius: 14, overflow: 'hidden', background: '#fff', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', textDecoration: 'none', color: 'inherit' },
  thumb: { width: '100%', height: 200, objectFit: 'cover', objectPosition: 'top', display: 'block' },
  body: { padding: '14px 16px' },
  badge: { display: 'inline-block', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999, marginBottom: 8 },
  badgeOngoing: { background: '#e8f5e9', color: '#2e7d32' },
  badgeEnded: { background: '#eee', color: '#999' },
  cardTitle: { fontSize: 15, fontWeight: 700, color: '#333' },
};

export default EventsListPage;
